import { combineReducers } from 'redux';
import { componentsReducers } from '../components';
import { routesReducers } from '../routes';
import { apiReducers } from '../api';
import { servicesReducers } from '../ocab-services';
import { experienceReducers } from '../monetate-experience/reducer';
import { connectRouter } from 'connected-react-router';

// Note: Removed redux-form reducer since forms now use react-final-form
export default (history) =>
  combineReducers({
    router: connectRouter(history),
    ...componentsReducers,
    ...routesReducers,
    ...apiReducers,
    ...servicesReducers,
    ...experienceReducers,
  });

export const rootReducer = combineReducers({
  ...componentsReducers,
  ...routesReducers,
  ...apiReducers,
  ...servicesReducers,
  ...experienceReducers,
});
